import MicroModal from 'micromodal';
import Splide from '@splidejs/splide';

$ = jQuery;

const setFunctions = function () {
  if (!$('.js-functions').length) {
    return;
  }

  const splide = new Splide('.js-functions', {
    type: 'fade',
    rewind: true,
    autoplay: true,
    arrows: false,
    pagination: false,
  });

  splide.on('mounted', () => {
    const links = document.querySelectorAll('.js-functions-pagination [data-slide]');

    links.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const index = parseInt(this.getAttribute('data-slide'));
        splide.go(index);
      });
    });

    // Highlight active link
    splide.on('move', index => {
      links.forEach(link => {
        link.classList.toggle('is-active', parseInt(link.getAttribute('data-slide')) === index);
      });
    });

    // Trigger highlight on mount
    splide.emit('move', splide.index);
  });

  splide.mount();
};

const setMethods = function () {
  if (!$('.js-methods').length) {
    return;
  }

  const splide = new Splide('.js-methods', {
    type: 'fade',
    rewind: true,
    autoplay: true,
    arrows: false,
    pagination: false,
  });

  splide.on('mounted', () => {
    const links = document.querySelectorAll('.js-methods-pagination [data-slide]');

    links.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const index = parseInt(this.getAttribute('data-slide'));
        splide.go(index);
      });
    });

    // Highlight active link
    splide.on('move', index => {
      links.forEach(link => {
        link.classList.toggle('is-active', parseInt(link.getAttribute('data-slide')) === index);
      });
    });

    // Trigger highlight on mount
    splide.emit('move', splide.index);
  });

  splide.mount();
};

const setReference = function () {
  if (!$('.js-reference').length) {
    return;
  }

  const splide = new Splide('.js-reference', {
    type: 'loop',
    perPage: 2,
    //focus: 'center',
    gap: '16px',
    padding: {left: '20%', right: '20%'},
    rewind: true,
    autoplay: true,
    arrows: false,
    pagination: false,
    breakpoints: {
      1399: {
        perPage: 2,
        padding: {left: '15%', right: '15%'},
      },
      1199: {
        perPage: 1,
      },
      800: {
        perPage: 1,
        padding: {left: '10%', right: '10%'},
      }
    }
  });

  splide.on('mounted', () => {
    const links = document.querySelectorAll('.js-reference-pagination [data-slide]');

    links.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const index = parseInt(this.getAttribute('data-slide'));
        splide.go(index);
      });
    });

    // Highlight active link
    splide.on('move', index => {
      links.forEach(link => {
        link.classList.toggle('is-active', parseInt(link.getAttribute('data-slide')) === index);
      });
    });

    // Trigger highlight on mount
    splide.emit('move', splide.index);
  });

  splide.mount();

  document.getElementById('reference-arrow-prev').addEventListener('click', () => {
    splide.go('<');
  });

  document.getElementById('reference-arrow-next').addEventListener('click', () => {
    splide.go('>');
  });
};

const setLogos = function () {
  if (!$('.js-logos').length) {
    return;
  }

  const splide = new Splide('.js-logos', {
    type: 'loop',
    rewind: true,
    autoWidth: true,
    gap: '24px',
    autoplay: true,
    interval: 2000,
    speed: 1000,
    focus: 'center',
    arrows: false,
    pagination: false,
  });

  splide.mount();
};

jQuery(document).ready(function ($) {
  $('.js-toggle-language-switcher').click(function (e) {
    e.preventDefault();

    $('.js-language-switcher').toggleClass('language-switcher--active');
  });

  MicroModal.init({
    onShow: () => {
      const iframe = document.querySelector('.video__wrapper iframe');
      if (iframe && iframe.dataset.src) {
        iframe.setAttribute('src', iframe.dataset.src);
      }
    },
    onClose: () => {
      const iframe = document.querySelector('.video__wrapper iframe');
      if (iframe) {
        const src = iframe.getAttribute('src');
        iframe.setAttribute('src', '');
        iframe.setAttribute('data-src', src);
      }
    }
  });

  setFunctions();
  setMethods();
  setReference();
  setLogos();

  $('[href^=#]').click(function (e) {
    e.preventDefault();
    let id = $(this).attr('href');
    let element = $(id);
    if (element.length) {
      $('html,body').animate({scrollTop: element.offset().top - 60}, 1000);
    }
  });

  $('.js-load-more-posts').click(function (e) {
    e.preventDefault();
    let button = $(this);
    let list = $('.js-post-list');
    let page = (parseInt(list.attr('data-page')) + 1);

    button.prop('disabled', true);

    $.ajax({
      url: vetnode.api_url + '/posts/' + page,
      method: 'GET',
      success: function (response) {
        button.prop('disabled', false);

        if ('' !== response.html) {
          list.append(response.html);

          if (response.count === 9) {
            list.attr('data-page', page);
          } else {
            button.hide();
          }
        } else {
          button.hide();
        }
      }
    });
  });

  $('.js-menu-button-open, .js-menu-button-close').click(function (e) {
    e.preventDefault();

    $('.js-menu-wrapper').toggleClass('open');
  });

  $('.js-toggle-faq').click(function (e) {
    e.preventDefault();
    $(this).parents('.js-faq-item').toggleClass('open');
  });
});